import { mapActions, mapGetters, mapState } from 'vuex'

const payBoxRewards = {
  computed: {
    ...mapState('reward', {
      mxStRewardBalance: 'rewardBalance',
    }),
    ...mapGetters('reward', {
      mxStHasRewardBalance: 'hasRewardBalance',
    }),

    ...mapState('pages/pdv/payBox', {
      mxStClientForm: 'clientForm',
    }),
    ...mapGetters('pages/pdv/payBox', {
      mxStIsOrder: 'isOrder',
      mxStHasRewardsApplied: 'hasRewardsApplied',
      mxStGetTotalSale: 'getTotalSale',
      mxStGetRewardsAmountUsed: 'getRewardsAmountUsed',
      mxStHasActivePayment: 'hasActivePayment',
      mxStSalePriceTableId: 'salePriceTableId',
    }),

    ...mapGetters('pages/pdv/payBoxConfiguration', ['currentPayboxConfiguration']),
    mxRewardIsAtm() {
      return this.currentPayboxConfiguration?.isAtm
    },
  },

  methods: {
    ...mapActions('reward', {
      mxStCalculateRewardDiscount: 'calculateRewardDiscount',
    }),

    ...mapActions('pages/pdv/payBox', {
      mxStApplyRewards: 'applyRewards',
    }),

    async mxReloadPayBoxRewardApplied() {
      const canReloadReward = !this.mxStIsOrder &&
        this.mxStHasRewardBalance &&
        this.mxStHasRewardsApplied &&
        !this.mxStHasActivePayment
      if (!canReloadReward) return

      const totalSaleWithoutRewardApplied = this.mxStGetTotalSale + (this.mxStGetRewardsAmountUsed)
      const allowedRewardsAmount = await this.mxStCalculateRewardDiscount({
        customerId: this.mxStClientForm.id,
        saleTotal: totalSaleWithoutRewardApplied,
        priceTableId: this.mxStSalePriceTableId,
      })

      if (this.mxStGetRewardsAmountUsed !== allowedRewardsAmount) {
        if (this.mxRewardIsAtm) {
          await this.showAtmAlert({
            title: 'Informação',
            text: this.$t('SALE.UI.ECASH.BALANCE_WILL_UPDATE'),
            icon: 'info'
          })
        } else {
          await this.showInformation({ text: this.$t('SALE.UI.ECASH.BALANCE_WILL_UPDATE') })
        }
      }

      if (allowedRewardsAmount < this.mxStRewardBalance.currentBalance) {
        if (!this.mxRewardIsAtm) {
          this.showInformation({
            title: this.$t('Limite excedido'),
            text: `O valor máximo de ecash que pode ser aplicadas nesta venda é de ${this.$options.filters.currency(
              allowedRewardsAmount
            )}`,
          })
        }
      }

      await this.mxStApplyRewards(allowedRewardsAmount)
    },
  },
}

export default payBoxRewards
